import { extractProperty } from "utils"
import { StateType } from "../ProductsLobby"

const isAnyFilterActive = (filterCategory: keyof StateType, state: StateType) =>
  state[filterCategory].some((filter) => {
    if (filter.number === 0) {
      return false
    }
    return filter.visibility
  })

const getSelectedValues = (filterCategory: keyof StateType, state: StateType) =>
  state[filterCategory]
    .filter((filter) => filter.visibility)
    .map((filter) => (filterCategory === "productKeyFeatures" ? filter.value : filter.id))

export const filterProducts = (products: any, state: StateType) => {
  return products?.filter((product: any) => {
    const selectedCategories = getSelectedValues("categories", state)
    const selectedSubCategories = getSelectedValues("subCategories", state)
    const selectedKeyFeatures = getSelectedValues("productKeyFeatures", state)
    const properties = product.properties || []
    const categories = properties
      .find((p: any) => p.propertyName === "productCategory")
      ?.propertyValue?.contentList?.map((cat: any) => cat.id)

    const subCategory = properties
      .find((p: any) => p.propertyName === "productSubCategory")
      ?.propertyValue?.contentList?.map((cat: any) => cat.id)
    const features = properties
      .find((p: any) => p.propertyName === "productKeyFeatures")
      ?.propertyValue?.blocks?.map((feature: any) => extractProperty(feature, "text"))

    const matchesCategories =
      !isAnyFilterActive("categories", state) ||
      categories.some((cat: number) =>
        selectedCategories.some((selectedCat) => selectedCat === cat),
      )
    const matchesSubCategories =
      !isAnyFilterActive("subCategories", state) ||
      subCategory.some((cat: number) =>
        selectedSubCategories.some((selectedCat) => selectedCat === cat),
      )
    const matchesKeyFeatures =
      !isAnyFilterActive("productKeyFeatures", state) ||
      features.some((feature: string) => selectedKeyFeatures.includes(feature))

    return matchesSubCategories && matchesKeyFeatures && matchesCategories
  })
}
